import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入基础样式
import 'src/styles/index.styl'

// 注入svg-icon
import 'src/icons'

// 引入vant
import 'src/components/vant'
import 'vant/lib/icon/local.css'
import '@vant/touch-emulator'

if (!['production'].includes(process.env.VUE_APP_ENV) && window.location.hostname !== 'localhost') {
  new VConsole()
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
